var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9998 6.00082L20.9998 6.00148C22.0998 6.00157 22.9998 6.90164 22.9997 8.00164L22.9989 18.0016C22.9988 19.1016 22.0987 20.0016 20.9987 20.0015L4.99869 20.0002C3.89869 20.0001 2.99876 19.1 2.99885 18L3.00984 6C3.00993 4.9 3.9 4.00007 5 4.00016L11 4.00066L12.9998 6.00082ZM4.99967 8.00016L4.99885 18.0002L20.9989 18.0015L20.9997 8.00148L4.99967 8.00016Z",
    fill: "#505255"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen24Px);
export default __webpack_public_path__ + "static/media/folder_open_24px.8d13deac98135447fb47551f8793e583.svg";
export { ForwardRef as ReactComponent };